"use client";

import { usePathname, useRouter } from "next/navigation";
import { openLoginModalWithRedirect } from "@/utils/auth-modal";

export default function FloatingStoreCart() {
  const pathname = usePathname();
  const router = useRouter();

  if (!pathname?.startsWith("/store")) {
    return null;
  }

  const isProductDetailsPage = pathname.includes("/store/product-details/");

  const handleClick = () => {
    if (openLoginModalWithRedirect(router, "/user/cart")) {
      return;
    }

    router.push("/user/cart");
  };

  return (
    <button
      type="button"
      aria-label="Open cart"
      onClick={handleClick}
      className={`fixed left-4 z-[10] flex h-[64px] w-[64px] items-center justify-center transition-all duration-200 hover:scale-105 md:h-[80px] md:w-[80px] rounded-full glass-effect border border-[#d9ac4f] shadow-[0_0_15px_rgba(217,172,79,0.3)] hover:shadow-[0_0_20px_rgba(217,172,79,0.5)] ${
        isProductDetailsPage ? "bottom-35" : "bottom-4"
      } md:bottom-4`}
    >
      <svg
        className="w-[28px] h-[28px] md:w-[36px] md:h-[36px] text-[#d9ac4f]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="8" cy="21" r="1" />
        <circle cx="19" cy="21" r="1" />
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
      </svg>
    </button>
  );
}